<template>
  <div id='bd-profile'>
    <el-form ref="form" :rules="rules" :model="form" label-width="120px" style="margin-top: 20px;">
      <el-form-item :label="subDomainTip" prop="subDomain">
          <el-input v-model="userInfo.subDomain" style="width: 300px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="usernameTip" prop="username">
          <el-input v-model="userInfo.username" style="width: 300px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="nicknameTip" prop="nickname">
          <el-input v-model="userInfo.nickname" style="width: 300px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="realNameTip" prop="realName">
          <el-input v-model="userInfo.realName" style="width: 300px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="avatarTip" prop="avatar">
          <img :src="userInfo.avatar" width="40px" height="40px" style="float: left; margin-right: 15px;"/>
          <el-upload
            class="upload-demo"
            :data="upload_data"
            :name="upload_name"
            :action="uploadImageServerUrl"
            :on-success="handleImageUploadSuccess"
            :before-upload="beforeImageUpload">
            <el-button size="small" type="primary" :disabled="true">{{ uploadTip }}</el-button>
          </el-upload>
      </el-form-item>
      <el-form-item :label="mobileTip" prop="mobile">
          <el-input v-model="userInfo.mobile" style="width: 300px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="emailTip" prop="email">
          <el-input v-model="userInfo.email" style="width: 300px;" :disabled="true"></el-input>
      </el-form-item>
      <!-- <el-form-item label="角色" prop="email">
          <el-input v-model="form.email"></el-input>
      </el-form-item> -->
      <el-form-item :label="descriptionTip" prop="description">
        <el-input type="textarea" :rows="2" :placeholder="tooLazyTip" v-model="userInfo.description" style="width: 300px;" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" @click="editProfile">{{ editTip }}</el-button>
      </el-form-item>
    </el-form>
    <el-dialog v-dialogDrag
      :title="editProfileTip"
      :visible.sync="editProfileDialogVisible"
      width="50%"
      center>
      <el-form ref="form" :rules="rules" :model="form" label-width="120px" style="margin-top: 20px;">
        <!-- FIXME: 一个管理员账号修改用户名后不能登录，因此暂且禁止修改用户名 -->
        <el-form-item :label="usernameTip" prop="username">
            <el-input v-model="form.username" style="width: 250px;" disabled></el-input>
        </el-form-item>
        <el-form-item :label="newPasswordTip" prop="password">
          <el-input v-model="form.password" auto-complete="off" :placeholder="passwordTip" style="width: 250px;"></el-input>
        </el-form-item>
        <el-form-item :label="nicknameTip" prop="nickname">
            <el-input v-model="form.nickname" style="width: 250px;"></el-input>
        </el-form-item>
        <el-form-item :label="avatarTip" prop="avatar">
          <img :src="form.avatar" width="40px" height="40px" style="float: left; margin-right: 15px;"/>
          <el-upload
            class="upload-demo"
            :data="upload_data"
            :name="upload_name"
            :action="uploadImageServerUrl"
            :on-success="handleImageUploadSuccess"
            :before-upload="beforeImageUpload">
            <el-button size="small" type="primary">{{ uploadTip }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="mobileTip" prop="mobile">
            <el-input v-model="form.mobile" style="width: 250px;" disabled></el-input>
        </el-form-item>
        <el-form-item :label="emailTip" prop="email">
            <el-input v-model="form.email" style="width: 250px;" disabled></el-input>
        </el-form-item>
        <el-form-item :label="descriptionTip" prop="description">
          <el-input type="textarea" :rows="2" :placeholder="tooLazyTip" v-model="form.description" style="width: 250px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editProfileDialogVisible = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" @click="doUpdateProfile">{{ $t('save') }}</el-button>
      </span>
    </el-dialog>
    <!-- <el-checkbox v-model="shouldPlayAudio" @change="onPlayAudioChange" style="margin-left: 50px;">{{ $t('playAudio') }}</el-checkbox><br>
    <el-checkbox v-model="shouldShowNotificationWindow" @change="onShowNotificationWindowChange" style="margin-left: 50px;">{{ $t('showNotificationWindow') }}</el-checkbox><br>
    <el-checkbox v-model="showBottomStatistics" @change="onShowBottomStatisticChange" style="margin-left: 50px;">{{ $t('showBottomStatistics') }}</el-checkbox><br>
    <el-checkbox v-model="showOutOfTime" @change="onShowOutOfTimeChange" style="margin-left: 50px;">{{ $t('showOutOfTime') }}</el-checkbox><br>
    <el-checkbox v-model="shouldShowInputTips" @change="onShowInputTipsChange" style="margin-left: 50px;">{{ $t('showInputTip') }}</el-checkbox><br>
    <el-checkbox v-model="shouldQueryMpQrcodeUrl" @change="onQueryMpQrcodeUrlChange" style="margin-left: 50px;">{{ $t('queryMpQrcodeUrl') }}</el-checkbox><br> -->
    <!-- <span style="margin-left: 50px;">v{{ version }}</span> -->
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
const constants = require('@/util/constants')
// import bus from '@/util/eventbus'

export default {
  name: 'bd-profile',
  data () {
    return {
      version: process.env.VUE_APP_VERSION,
      editProfileDialogVisible: false,
      form: {
        username: '',
        password: '',
        name: '',
        avatar: '',
        mobile: '',
        email: '',
        description: '',
        welcomeTip: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        avatar: [
          { required: true, message: '上传头像', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入简介', trigger: 'blur' }
        ]
      },
      // 上传图片相关参数
      upload_headers: {
        'X-CSRF-TOKEN': '',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Authorization': 'Bearer '
      },
      upload_data: {
        file_name: 'test.png',
        username: ''
      },
      upload_name: 'file',
      uploadImageServerUrl: constants.UPLOAD_IMAGE_URL,
      isIp: constants.IS_IP,
      electron: constants.IS_ELECTRON,
      shouldPlayAudio: true,
      shouldShowNotificationWindow: true,
      showBottomStatistics: true,
      showOutOfTime: true,
      shouldShowInputTips: true,
      shouldQueryMpQrcodeUrl: true
    }
  },
  computed: {
    ...mapGetters([ 'userInfo' ]),
    // uploadImageServerUrl () {
    //   return constants.UPLOAD_IMAGE_URL
    // },
    subDomainTip () {
      return this.$t('subDomain')
    },
    usernameTip () {
      return this.$t('username')
    },
    nicknameTip () {
      return this.$t('nickname')
    },
    realNameTip () {
      return this.$t('realName')
    },
    mobileTip () {
      return this.$t('mobile')
    },
    emailTip () {
      return this.$t('email')
    },
    avatarTip () {
      return this.$t('avatar')
    },
    descriptionTip () {
      return this.$t('description')
    },
    editTip () {
      return this.$t('edit')
    },
    uploadTip () {
      return this.$t('upload')
    },
    editProfileTip () {
      return this.$t('editprofile')
    },
    passwordTip () {
      return this.$t('password')
    },
    newPasswordTip () {
      return this.$t('newpassword')
    },
    tooLazyTip () {
      return this.$t('tooLazy')
    }
  },
  methods: {
    ...mapActions([ 'updateProfile', 'updateShowBottomStatistics', 'updateShowOutOfTime', 'updateShowInputTips', 'updateQueryMpQrcodeUrl' ]),
    // username (usernameAtSubDomain) {
    //   console.log('userInfo:', this.userInfo)
    //   if (this.userInfo.agent) {
    //     return usernameAtSubDomain.split('@')[0]
    //   } else {
    //     return usernameAtSubDomain
    //   }
    // },
    handleImageUploadSuccess (result, file) {
      console.log('upload image success result:', result, ' file:', file)
      if (result.status_code === 200) {
        this.form.avatar = result.data
      } else {
        this.$message.error('上传图片错误，请稍后重试...')
      }
    },
    beforeImageUpload (file) {
      // console.log('before image upload file:', file)
      const isJPGorPNG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt2M = file.size / 1024 / 1024 < 2
      // 验证图片格式
      if (!isJPGorPNG) {
        this.$message.error('上传头像图片只能是 jpg 或 png 格式!')
      }
      // 验证图片大小
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      // 设置文件名
      let filename = moment(new Date()).format('YYYYMMDDHHmmss')
      if (file.type === 'image/jpeg') {
        this.upload_data.file_name = filename + '.jpg'
      } else if (file.type === 'image/png') {
        this.upload_data.file_name = filename + '.png'
      }
      // 返回
      return isJPGorPNG && isLt2M
    },
    doUpdateProfile () {
      console.log('updateProfile')
      // if (this.userInfo.agent) {
      //   this.form.username = this.form.username + '@' + this.form.subDomain
      // }
      this.updateProfile(this.form)
      this.editProfileDialogVisible = false
    },
    editProfile () {
      console.log('userInfo:', this.userInfo)
      this.form.subDomain = this.userInfo.subDomain
      // if (this.userInfo.agent) {
      //   this.form.username = this.userInfo.username.split('@')[0]
      // } else {
      this.form.username = this.userInfo.username
      // }
      this.form.nickname = this.userInfo.nickname
      this.form.avatar = this.userInfo.avatar
      this.form.mobile = this.userInfo.mobile
      this.form.email = this.userInfo.email
      this.form.description = this.userInfo.description
      this.form.welcomeTip = this.userInfo.welcomeTip
      //
      this.editProfileDialogVisible = true
    },
    // 监听播放声音设置
    onPlayAudioChange (value) {
      // console.log('check:', value)
      Vue.ls.set(constants.PLAY_AUDIO, value)
    },
    onShowNotificationWindowChange (value) {
      // console.log('check:', value)
      Vue.ls.set(constants.SHOW_NOTIFICATION_WINDOW, value)
    },
    onShowBottomStatisticChange (value) {
      // console.log('statistic check:', value)
      Vue.ls.set(constants.SHOW_BOTTOM_STATISTIC, value)
      this.updateShowBottomStatistics(value)
    },
    onShowOutOfTimeChange (value) {
      // console.log('out of time check:', value)
      Vue.ls.set(constants.SHOW_OUT_OF_TIME, value)
      this.updateShowOutOfTime(value)
    },
    onShowInputTipsChange (value) {
      // console.log('input tips check:', value)
      Vue.ls.set(constants.SHOW_INPUT_TIPS, value)
      this.updateShowInputTips(value)
    },
    onQueryMpQrcodeUrlChange (value) {
      // console.log('input tips check:', value)
      Vue.ls.set(constants.QUERY_MPQRCODE_URL, value)
      this.updateQueryMpQrcodeUrl(value)
    }
  },
  // mounted() {
  // },
  created() {
    this.shouldPlayAudio = Vue.ls.get(constants.PLAY_AUDIO, true)
    this.shouldShowNotificationWindow = Vue.ls.get(constants.SHOW_NOTIFICATION_WINDOW, true)
    this.showBottomStatistics = Vue.ls.get(constants.SHOW_BOTTOM_STATISTIC, true)
    this.showOutOfTime = Vue.ls.get(constants.SHOW_OUT_OF_TIME, false)
    this.shouldShowInputTips = Vue.ls.get(constants.SHOW_INPUT_TIPS, true)
    this.shouldQueryMpQrcodeUrl = Vue.ls.get(constants.QUERY_MPQRCODE_URL, true)
  },
}
</script>

<style scoped>
#bd-profile {
  height: 100%;
  overflow: auto;
  text-align: left;
}
</style>
